module.exports = __webpack_public_path__ + "img/244706e.png";